import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Lightbox from '../lightbox/lightbox';
import TextInput from '../form/floating_label/text_input';
import Select from '../form/floating_label/select';
import Translation from '../translation/translation';
import TranslationContainer from '../translation/translation_container';
import { NotificationTypes } from '../../constants/notify_me/notification_types';
import getTranslatedText from '../../helper/get_translated_text';

function NotifyMe(props) {
    const [forceDisable, setForceDisable] = useState(false);
    const disabled = forceDisable || !props.name || (!props.email && !props.phone) || !props.sku;
    const { quantity, tyreQuantityOptions, isSubmitted, isError, errorMsg } = props;
    const isOutOfStock = NotificationTypes.OUT_OF_STOCK === props.type;
    const headlineTranslationKey = isOutOfStock ? 'notify-me-header-out-of-stock' : 'notify-me-header';
    const submitTranslationKey = isOutOfStock ? 'notify-me-submit-label-out-of-stock' : 'notify-me-submit-label';

    const onChange = (value, name) => {
        setForceDisable(false);
        props.onChange(value, name);
    };

    return (
        <Lightbox additionalClassNames={['lightbox--notify-me']} opened={props.visible} onClose={props.onClose}>
            <div className="notify-me">
                <div className="lightbox__header">
                    <Translation translationKey={headlineTranslationKey} />
                </div>

                <form className="notify-me__form" onSubmit={e => { e.preventDefault(); setForceDisable(true); props.onSubmit(e); }}>
                    <input type="hidden" value={props.sku} name="sku" />
                    <TranslationContainer
                        targetProperties={{
                            label: { translationKey: 'quantity-needed-label' }
                        }}
                    >
                        <Select
                            name='quantity'
                            value={quantity}
                            label="to be replaced"
                            options={tyreQuantityOptions}
                            hasValue={!!quantity}
                            onChange={onChange}
                            highlight={!props.quantity}
                        />
                    </TranslationContainer>

                    <TranslationContainer
                        targetProperties={{
                            label: { translationKey: 'notify-me-name-label' }
                        }}
                    >
                        <TextInput
                            name="name"
                            value={props.name}
                            onChange={onChange}
                            label="will-be-replaced"
                            highlight={!props.name}
                        />
                    </TranslationContainer>

                    <TranslationContainer
                        targetProperties={{
                            label: { translationKey: 'notify-me-email-label' },
                            errorText: { translationKey: 'notify-me-email-errorText' }
                        }}
                    >
                        <TextInput
                            name="email"
                            value={props.email}
                            onChange={onChange}
                            label="will-be-replaced"
                            highlight={!!props.name && !props.email}
                            invalid={props.emailInvalid}
                        />
                    </TranslationContainer>

                    <TranslationContainer
                        targetProperties={{
                            label: { translationKey: 'notify-me-phone-label' },
                            errorText: { translationKey: 'notify-me-phone-errorText' }
                        }}
                    >
                        <TextInput
                            name="telephone"
                            value={props.phone}
                            onChange={onChange}
                            label="will-be-replaced"
                            highlight={!!props.name && !!props.email}
                            invalid={props.phoneInvalid}
                        />
                    </TranslationContainer>
                    {isSubmitted && !isError && <p>
                        <strong className="text-green">{getTranslatedText('thank-you-interest-note')}
                        </strong>&nbsp;{getTranslatedText('notify-get-back-to-you')}
                    </p>}
                    {isSubmitted && isError && <p>
                        <strong className="text-red">
                            {getTranslatedText('error-note')}&nbsp;{errorMsg}
                        </strong>
                    </p>}

                    <div className="form-group checkbox">
                        <label style={{ fontWeight: 500 }}>
                            <input
                                name="marketing-consent"
                                className="marketing-consent"
                                type="checkbox"
                                onChange={(e) => onChange(e.currentTarget.checked, 'marketing-consent')}
                            />
                            {getTranslatedText('receive-market-communications-text')}
                        </label>
                    </div>

                    <TranslationContainer translationKey={submitTranslationKey} targetProperty="value">
                        <input type="submit" className="notify-me__submit" disabled={disabled} />
                    </TranslationContainer>

                    <p className="mt-10">{getTranslatedText('agree-to-tyroola-term')}&nbsp;
                        <a className="underline"
                            href="/terms-and-conditions/"
                            target="_blank">{getTranslatedText('footer-meta-nav-tnc')}</a>
                        &nbsp;{getTranslatedText('text-and')}&nbsp;
                        <a className="underline"
                            href="/privacy/"
                            target="_blank">{getTranslatedText('footer-meta-nav-privacy')}</a>
                    </p>
                </form>
            </div>
        </Lightbox >
    );
}

NotifyMe.propTypes = {
    quantity: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    phone: PropTypes.string.isRequired,
    tyreQuantityOptions: PropTypes.array.isRequired,
    sku: PropTypes.string.isRequired,
    type: PropTypes.number.isRequired,
    visible: PropTypes.bool.isRequired,
    emailInvalid: PropTypes.bool.isRequired,
    phoneInvalid: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    isSubmitted: PropTypes.bool.isRequired,
};

export default NotifyMe;
